document.addEventListener('DOMContentLoaded', () => {
    MAIN.onReady();
});

const MAIN = {
    onReady() {
        FORM.onReady();
        // "fields" is a constant build in PHP
        if (typeof fields !== 'undefined') {
            APP.onReady();
        }
        DOWNLOAD.onReady();
        DROPDOWN.onReady();
        FILEPOND.onReady();
        NICESELECT.onReady();
        TABS.onReady();
        ZOOM.onReady();
        MODAL.onReady();
    }
}